import React from 'react'
import styles from './ParagraphText.module.css'
import ReactMarkdown from 'react-markdown'

const ParagraphText = (props) => {
  return (
    <div className={`${styles.container} ${styles.containerFullWidth}`}>
      <ReactMarkdown allowDangerousHtml>{props.html}</ReactMarkdown>
    </div >
  )
}

export default ParagraphText
